/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Action_New_Resume_DescInputs */

const en_dashboard_action_new_resume_desc = /** @type {(inputs: Dashboard_Action_New_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload an existing resume or create one from scratch with AI assistance.`)
};

const de_dashboard_action_new_resume_desc = /** @type {(inputs: Dashboard_Action_New_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lade einen bestehenden Lebenslauf hoch oder erstelle einen von Grund auf mit KI-Unterstützung.`)
};

const fr_dashboard_action_new_resume_desc = /** @type {(inputs: Dashboard_Action_New_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharge un CV existant ou crée-en un de zéro avec l'aide de l'IA.`)
};

const es_dashboard_action_new_resume_desc = /** @type {(inputs: Dashboard_Action_New_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suba un currículum existente o cree uno desde cero con asistencia de IA.`)
};

const it_dashboard_action_new_resume_desc = /** @type {(inputs: Dashboard_Action_New_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica un curriculum vitae esistente o creane uno da zero con l'assistenza dell'AI.`)
};

const nl_dashboard_action_new_resume_desc = /** @type {(inputs: Dashboard_Action_New_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload een bestaand cv of maak er een van scratch met AI-assistentie.`)
};

const pl_dashboard_action_new_resume_desc = /** @type {(inputs: Dashboard_Action_New_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wgraj istniejące CV lub stwórz je od podstaw z pomocą AI.`)
};

const fi_dashboard_action_new_resume_desc = /** @type {(inputs: Dashboard_Action_New_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataa olemassa oleva ansiotodistus tai luo uusi alusta alkaen AI-avustuksella.`)
};

const da_dashboard_action_new_resume_desc = /** @type {(inputs: Dashboard_Action_New_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload et eksisterende CV eller opret et nyt fra bunden med AI-assistance.`)
};

const sv_dashboard_action_new_resume_desc = /** @type {(inputs: Dashboard_Action_New_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladda upp ett befintligt CV eller skapa ett från grunden med AI-assistans.`)
};

/**
* | output |
* | --- |
* | "Upload an existing resume or create one from scratch with AI assistance." |
*
* @param {Dashboard_Action_New_Resume_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_action_new_resume_desc = /** @type {((inputs?: Dashboard_Action_New_Resume_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Action_New_Resume_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_action_new_resume_desc(inputs)
	if (locale === "fr") return fr_dashboard_action_new_resume_desc(inputs)
	if (locale === "es") return es_dashboard_action_new_resume_desc(inputs)
	if (locale === "it") return it_dashboard_action_new_resume_desc(inputs)
	if (locale === "nl") return nl_dashboard_action_new_resume_desc(inputs)
	if (locale === "pl") return pl_dashboard_action_new_resume_desc(inputs)
	if (locale === "fi") return fi_dashboard_action_new_resume_desc(inputs)
	if (locale === "da") return da_dashboard_action_new_resume_desc(inputs)
	if (locale === "sv") return sv_dashboard_action_new_resume_desc(inputs)
	return en_dashboard_action_new_resume_desc(inputs)
});